import React,{useState, useEffect} from 'react'
import {Container,Row,Col} from 'react-bootstrap'
import '../Styles/barraSecundaria.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {Link} from "react-router-dom"

import { db } from "../firebase";
import { collection, getDocs, query,limit,orderBy } from "firebase/firestore";

function SampleNextArrow(props) {
  const { className, style} = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none"}}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style} = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none"}}
    />
  );
}

const BarraSecundaria = () => {

  const [data2, setData2] = useState([]);
  const getData = async () => {
    try {
      const dataRef = collection(db, "productos");
      const q = query(
        dataRef,
        orderBy("fecha","desc"),
        limit(6)
      );
      //db.collection("Habitaciones").orderBy("fecha_ingreso", "desc").limit(22).onSnapshot((querySnapshot) =>
      //lo de arriba podria usarlo cuando tenga los datos de las fechas de registro
      //para poder poner la data en orden secuencial de los mas nuevos
      const querySnapshot = await getDocs(q);

      const dataDB = querySnapshot.docs.map((doc) => doc.data());
      setData2(dataDB);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const settings = {
    className: "",
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Container fluid="100%">
        <Row>
          <Col>
            <div className="barraSecundaria">
              {/* <Link to={`/productos`} style={{ textDecoration: 'none', color:'inherit'}}> */}
              <Link to={`/productosNavidad`} style={{ textDecoration: 'none', color:'inherit'}}>
                <div className='barraSecundaria_titulo'>
                  {/* <h3>Visita nuestros nuevos productos</h3> */}
                  <h3>🎅🎄Ver campaña Navidad🎄🎅</h3>
                </div>
              </Link>

              <div className='carrousel'>
                <Slider {...settings}>
                  {/* <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(1).jpg' alt="img_carrousel" />
                  </div>
                  <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(2).jpg' alt="img_carrousel" />
                  </div>
                  <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(3).jpg' alt="img_carrousel" />
                  </div>
                  <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(4).jpg' alt="img_carrousel" />
                  </div>
                  <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(5).jpg' alt="img_carrousel" />
                  </div>
                  <div className='carrousel_img'>
                    <img src='./products/navidad/navidad_(6).jpg' alt="img_carrousel" />
                  </div> */}

                  {data2.length > 0 ? (
                    data2.map((item) => (
                      <div key={item.id} className='carrousel_img'>
                        <img src={item.imagen} alt="img_carrousel"/>
                      </div>
                    ))
                  ): (
                    <p>No hay productos aun</p>
                  )}

                </Slider>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
  )
}

export default BarraSecundaria